module.exports = __webpack_public_path__ + "static/img/AD.384bfdb7.png";